import { render, staticRenderFns } from "./BarProductGallery.vue?vue&type=template&id=a8dbb786&scoped=true"
import script from "./BarProductGallery.vue?vue&type=script&lang=js"
export * from "./BarProductGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dbb786",
  null
  
)

export default component.exports